export default __webpack_public_path__ + "static/media/marketwisdom.78eef269.png";